import { editSigningPhysiciansOptions, PatientPhysicianAssociationEnum } from '@generated';
import { PhysicianRowLabel } from './PhysicianRowLabel';
import { OrderItems } from '../OrderItems';
import { OrderPhysiciansFormModal } from './OrderPhysiciansFormModal';
import { SectionListRow } from '~/shared/section/section-list/SectionListRow';
import { useFullOrder } from '../orders/FullOrderContext';

export function NewSigningPhysicians() {
	const { fullOrder } = useFullOrder();
	return (
		<OrderItems
			title="New Signing Physicians"
			items={fullOrder.newSigningPhysicians.map(e => (
				<SectionListRow key={e.patientPhysicianId} label={<PhysicianRowLabel patientPhysician={e.patientPhysician} notes={e.notes} />} />
			))}
			sectionButtonProps={{
				useSuspense: true,
				renderModal: closeModal => (
					<OrderPhysiciansFormModal
						title="New Signing Physicians"
						order={fullOrder}
						currentPhysicians={fullOrder.newSigningPhysicians}
						filterEligible={p =>
							!p.acceptingOrders &&
							p.patientPhysicianAssociationId !== PatientPhysicianAssociationEnum.Primary &&
							p.patientPhysicianAssociationId !== PatientPhysicianAssociationEnum.Referring
						}
						saveMutation={editSigningPhysiciansOptions}
						commandListKey="newSigningPatientPhysicians"
						closeModal={closeModal}
					/>
				)
			}}
		/>
	);
}
